import React, { FC, memo, useCallback } from 'react';
import classNames from 'classnames';

import Radio from '@zvuk-b2b/react-uikit/ui/Radio';

import { PlayerTypesInFlow, DeviceTypesInFlow, VideoDeviceType } from '../../types';
import { PlayerRadioType } from '../types';
import { DEVICE_TO_PLAYER_TYPE } from '../consts';
import { TEXTS } from '../texts';

import styles from './index.module.scss';

interface PlayerTypeRadioProps {
  player: PlayerRadioType;
  selectedPlayer: PlayerTypesInFlow;
  pointDevice?: DeviceTypesInFlow | VideoDeviceType;
  onPlayerChange: (playerType: PlayerTypesInFlow) => void;
  haveBoundDevice: boolean;
}

const PlayerTypeRadio: FC<PlayerTypeRadioProps> = ({
  player,
  selectedPlayer,
  pointDevice,
  onPlayerChange,
  haveBoundDevice,
}) => {
  const isBoundType = pointDevice && player.type === DEVICE_TO_PLAYER_TYPE[pointDevice];
  const showBoundNote = haveBoundDevice && isBoundType;

  const handleChange = useCallback(
    (_: boolean) => {
      onPlayerChange(player.type);
    },
    [onPlayerChange, player]
  );

  return (
    <Radio
      onChange={handleChange}
      key={`stream_bind_select_player_${player.type}`}
      elementId={`stream_bind_select_player_${player.type}`}
      isChecked={player.type === selectedPlayer}
      className={styles.radio}>
      <div className={styles.radioTitle}>{player.title}</div>

      <div className={classNames(styles.radioDescription, showBoundNote && styles.radioDescriptionBound)}>
        {showBoundNote ? TEXTS.CHOSEN_DEVICE_TYPE : player.description}
      </div>
    </Radio>
  );
};

export default memo(PlayerTypeRadio);
